document.addEventListener('DOMContentLoaded', function() {

  const cursor = document.getElementById('cursor');
  const ring   = document.getElementById('cursor-ring');
  if (cursor && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      cursor.style.left = mx + 'px';
      cursor.style.top  = my + 'px';
    });
    function animateRing() {
      rx += (mx - rx) * 0.12;
      ry += (my - ry) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();
    document.querySelectorAll('a,button,.plant-card,.filter-btn').forEach(el => {
      el.addEventListener('mouseenter', () => {
        cursor.style.transform = 'translate(-50%,-50%) scale(2)';
        ring.style.width = '48px'; ring.style.height = '48px';
      });
      el.addEventListener('mouseleave', () => {
        cursor.style.transform = 'translate(-50%,-50%) scale(1)';
        ring.style.width = '28px'; ring.style.height = '28px';
      });
    });
  }

  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    reveals.forEach(r => obs.observe(r));
  }

  const sections = ['hero','collection','the-index','about','contact'];
  const dots = document.querySelectorAll('.page-dot');
  if (dots.length) {
    dots.forEach(d => {
      d.addEventListener('click', () => {
        const target = document.querySelector(d.dataset.target);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
    const secObs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const idx = sections.indexOf(e.target.id);
          dots.forEach((d, i) => d.classList.toggle('active', i === idx));
        }
      });
    }, { threshold: 0.4 });
    sections.forEach(id => {
      const el = document.getElementById(id);
      if (el) secObs.observe(el);
    });
  }

  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('.plant-card').forEach(card => {
        if (!filter || filter === 'all') {
          card.style.display = 'block';
        } else {
          card.style.display = card.dataset.rarity === filter ? 'block' : 'none';
        }
      });
    });
  });

  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('.product-main-img img');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    });
  });

  const addToCartForm = document.querySelector('[data-product-form]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = this.querySelector('.product-add-btn');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      const formData = new FormData(this);
      fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added to collection ✦';
        updateCartCount();
        setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2500);
      })
      .catch(() => { btn.textContent = 'Error — try again'; btn.disabled = false; });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        let countEl = document.querySelector('.cart-count');
        if (cart.item_count > 0) {
          if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'cart-count';
            document.querySelector('.nav-cart').appendChild(countEl);
          }
          countEl.textContent = cart.item_count;
        } else if (countEl) {
          countEl.remove();
        }
      });
  }

  document.querySelectorAll('.qty-input').forEach(input => {
    input.addEventListener('change', function() {
      const line = this.dataset.line;
      const qty  = parseInt(this.value);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      })
      .then(r => r.json())
      .then(() => location.reload());
    });
  });
const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('nav-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        hamburger.classList.remove('open');
        mobileMenu.classList.remove('open');
      });
    });
  }
});